// Define a plugin to handle jsPDF loading
// This ensures jsPDF is only loaded in the browser, not during SSR

export default defineNuxtPlugin((nuxtApp) => {
  // This plugin doesn't need to register anything
  // We'll import jsPDF dynamically directly in the components that need it
});
